<template>
  <div>
    <!-- 立即购买弹框 -->
    <van-popup
      v-model="buyNowShow"
      position="top"
      closeable
      class="buy-pop"
      :style="{ backgroundColor: '#f1f1f1' }"
      @open="openNewBuyNowPop"
      @close="closePop"
    >
      <div class="wrap">
        <!-- 主体内容 -->
        <div>
          <!-- <div class="content-box-title">
            版本种类
          </div> -->
          <div class="content">
            <div class="content-userinfo">
              {{ buyItemProduct.name }}
            </div>
            <div class="content-buy-type">
              <div
                class="content-buy-type-item"
                :class="{ choiceItem: currentIndex === index }"
                v-for="(good, index) in buyNowItem"
                :key="index"
                @click="changeChoiceItem(index)"
              >
                <p
                  style="height:20px;font-size:14px;font-weight:bold;color:#232323;margin-bottom:6px;"
                >
                  {{ good.salenumber }}
                  <span v-if="billingType == '1'">年</span>
                  <span v-if="billingType == '2'">天</span>
                </p>
                <div
                  style="height:24px;margin-bottom:4px;color:#ED702E;font-weight:bold;"
                >
                  <!-- <span style="font-size:14px;margin-right:4px;">&yen;</span> -->
                  <span style="font-size:20px;">{{ good.newprice }}元</span>
                </div>
                <div style="height:20px;margin-bottom:6px;">
                  <p
                    v-if="good.oriprice !== good.newprice"
                    class="original-price"
                  >
                    {{ good.oriprice }}&nbsp;元
                  </p>
                </div>
                <i
                  style="width:74px;height:1px;background-color:#EBE5D0;margin-bottom:5px;"
                ></i>
                <div style="color:#7E8085;text-align:center; padding:0 4px">
                  {{ good.discountdesc }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 优惠信息内容 -->
        <div class="favourable-box" v-if="!isXuFei">
          <p class="favourable-box-title">
            优惠信息
          </p>
          <div class="favourable-box-content">
            <van-cell-group>
              <van-field
                v-if="isConpponma"
                :disabled="checkedFavourable"
                clearable
                v-model="couponValue"
                label="优惠码"
                placeholder="请输入优惠码"
                input-align="right"
              />
              <van-field
                :disabled="checkedFavourable"
                clearable
                v-model="agentValue"
                label="运营商编码"
                placeholder="请输入运营商编码"
                input-align="right"
              />
            </van-cell-group>
          </div>
          <div class="check-coupon" style="text-align:right;">
            <van-checkbox
              v-model="checkedFavourable"
              @change="changeChecked"
              :disabled="
                (agentValue === '' && couponValue === '') || checkFavDiab
                  ? true
                  : false
              "
              >确认使用{{
                isConpponma ? "优惠码和" : ""
              }}运营商编码</van-checkbox
            >
            <span
              :style="{ color: couponAndAgentMsg.couponrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.couponrltdesc"
            >
              {{ couponAndAgentMsg.couponrltdesc + " " }}
            </span>
            <span
              :style="{ color: couponAndAgentMsg.agentrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.agentrltdesc"
            >
              {{ couponAndAgentMsg.agentrltdesc + " " }}
            </span>
            <span
              :style="{ color: couponAndAgentMsg.agentrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.discountdesc"
            >
              {{ couponAndAgentMsg.discountdesc }}
            </span>
          </div>
        </div>
        <!-- 发票内容 -->
        <div class="invoice-box">
          <p class="invoice-box-title">发票</p>
          <van-cell
            title="发票"
            is-link
            :value="invoiceWord"
            @click="choiceInvoice"
          />
        </div>
        <!-- 支付方式内容 -->
        <div class="pay-way">
          <p class="pay-way-title">请选择支付方式</p>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <img
                    width="30"
                    height="30"
                    src="@/assets/shop/wx.png"
                    style="vertical-align:middle;margin-right:10px"
                  />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
      <!-- 确认支付 -->
      <div class="pay-box">
        <div class="pay-box-total">
          合计：
          <span style="font-size:20px;font-weight:bold;color:#ED6D2D">
            ￥{{totalPrice}}
          </span>
        </div>
        <div>
          <van-button
            round
            class="pay-btn"
            :loading="loadingFlag"
            style="width:160px;height:44px;"
            @click="onSubmit"
            >去支付</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 升级弹框 -->
    <van-popup
      v-model="updateNowShow"
      position="top"
      closeable
      class="buy-pop"
      :style="{ backgroundColor: '#f1f1f1' }"
      @open="openUpdateNowPop"
      @close="closePop"
    >
      <div class="wrap">
        <!-- 主体内容 -->
        <div class="update-content">
          <div>版本升级</div>
          <div class="update-content-box">
            <p>
              <i> 升级的版本信息：</i>从
              <b>{{ updateBuyNowItem.oriproductname }} </b>
              升级到
              <b>{{ updateBuyNowItem.upproductname }} </b>
            </p>
            <p>
              <i>原订单剩余天数：</i><b>{{ updateBuyNowItem.daysremainint }}</b
              >天
            </p>
            <p>
              <i>原订单结算余额：</i><b>{{ updateBuyNowItem.balance }}</b
              >元
            </p>
            <p>
              <i>需要支付的差额：</i><b>{{ updateBuyNowItem.spread }}</b
              >元
            </p>
          </div>
        </div>
        <!-- 优惠信息内容 -->
        <div class="favourable-box" v-if="isConpponma">
          <p class="favourable-box-title">
            优惠信息
          </p>
          <div class="favourable-box-content">
            <van-cell-group>
              <van-field
                v-if="isConpponma"
                :disabled="checkedFavourable"
                clearable
                v-model="couponValue"
                label="优惠码"
                placeholder="请输入优惠码"
                input-align="right"
              />
            </van-cell-group>
          </div>
          <div class="check-coupon" style="text-align:right;">
            <van-checkbox
              v-model="checkedFavourable"
              @change="changeChecked"
              :disabled="agentValue ? false : true"
              >确认使用优惠码</van-checkbox
            >
            <span
              :style="{ color: couponAndAgentMsg.couponrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.couponrltdesc"
            >
              {{ couponAndAgentMsg.couponrltdesc + " " }}
            </span>
            <span
              :style="{ color: couponAndAgentMsg.agentrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.agentrltdesc"
            >
              {{ couponAndAgentMsg.agentrltdesc + " " }}
            </span>
            <span
              :style="{ color: couponAndAgentMsg.agentrlt ? 'green' : 'red' }"
              v-show="couponAndAgentMsg.discountdesc"
            >
              {{ couponAndAgentMsg.discountdesc }}
            </span>
          </div>
        </div>
        <!-- 发票内容 -->
        <div class="invoice-box">
          <p class="invoice-box-title">发票</p>
          <van-cell
            title="发票"
            is-link
            :value="invoiceWord"
            @click="choiceInvoice"
          />
        </div>
        <!-- 支付方式内容 -->
        <div class="pay-way">
          <p class="pay-way-title">请选择支付方式</p>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <img
                    width="30"
                    height="30"
                    src="@/assets/shop/wx.png"
                    style="vertical-align:middle;margin-right:10px"
                  />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
      <!-- 确认支付 -->
      <div class="pay-box">
        <div class="pay-box-total">
          合计：<span style="font-size:20px;font-weight:bold;color:#ED6D2D">
            ￥{{updatePrice}}</span>
        </div>
        <div>
          <van-button
            class="pay-btn"
            round
            :loading="loadingFlag"
            style="width:160px;height:44px;"
            @click="onSubmit"
            >去支付</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 开票弹框页面 -->
    <invoice-page
      ref="invoice"
      :totalPrice="totalPrice"
      @getInvoiceParams="getInvoiceParams"
    ></invoice-page>

    <!-- 用户协议 -->
    <!-- 用户协议弹框 -->
    <van-popup
      v-model="userAgreementModal"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
      @open="openUserAgreement"
    >
      <div id="word_11"></div>

      <newUserAgreement
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      ></newUserAgreement>
      <van-tabbar
        :border="false"
        style="background-color: #fff;
            diaplay: flex;
            justify-content: center;
            align-items: center;
            height: 50px;"
      >
        <van-button
          style="height: 70%; width: 4rem"
          type="info"
          block
          round
          size="small"
          @click="agreePayMoney"
          >同意并确认支付</van-button
        >
        <van-button
          style="height: 70%; width: 100px; margin-left: 20px"
          type="default"
          block
          round
          size="small"
          @click="closePopup"
          >取消支付</van-button
        >
      </van-tabbar>
    </van-popup>
  </div>
</template>

<script>
import InvoicePage from "@/components/common/invoice";
import newUserAgreement from "@/components/newcommon/newUserAgreement";
import {
  errDialog,
  commonDialog,
  warningNotify,
  commonToast,
} from "@/utils/lib/toast.js";
// import { ISCONPPONMA } from "@/assets/js/gb.js";

import { wxpayFunc } from "@/utils/lib/wxpay.js";

import { closeApp } from "@/utils/lib/util.js";

export default {
  props: ["routerAgentCode", "buyNowItem", "buyItemProduct", "updateBuyNowItem", "isConpponma", "billingType"],

  data() {
    return {
      // 立即购买
      buyNowShow: false,
      // 升级
      updateNowShow: false,
      // 是否是续费
      isXuFei: false,

      choiceItem: {},
      currentIndex: 0,

      checkedFavourable: false,
      // isConpponma: ISCONPPONMA, // 是否有优惠码
      couponValue: "",
      //   couponValueMsg: "", // 优惠码返回信息
      agentValue: "",
      //   agentValueMsg: "", // 运营商返回信息
      couponAndAgentMsg: {}, // 优惠码和运营商返回信息

      invoiceData: {
        // 发票弹框的内容
        invoicetype: 1,
        invoiceheader: {
          headertype: 1,
          headername: "个人",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
        },
      },
      invoiceWord: "普通发票 个人",

      radioPay: "1",
      originalPrice: 0, // 原价
      totalPrice: 0, // 折后总价
      updatePrice: 0, // 升级总价
      loadingFlag: false,

      wxpayObj: {}, // 微信内支付信息
      dataForm: "", // 微信外支付信息

      userAgreementData: {}, // 用户协议内容
      sumMoney: 0,
      userAgreementModal: false,
      checkFavDiab: false, // 运营商是否可以更改
    };
  },
  components: {
    InvoicePage,
    newUserAgreement,
  },
  computed: {
    isWX() {
      return localStorage.getItem("WX_VERSION") * 1;
    },
    locationAgentcode: {
      get() {
        return sessionStorage.getItem("agentcode");
      },
      set(value) {
        sessionStorage.setItem("agentcode", value);
      },
    },
  },
  created () {
    if (this.routerAgentCode) {
      this.buyItemProduct.code = '000004'
    }
    console.log('扫描代理商编码1122====>')
  },
  methods: {
    // 检测是否以前有运营商
    async checkOlderAgent() {
      let res = await this.$http.reqGetRegFromAgent();
      console.log("check", res);
      if (res.item.fromagent !== "") {
        this.checkFavDiab = true;
        this.locationAgentcode = res.item.fromagent;
        // if(this.routerAgentCode) {
        //   commonToast('您已经扫码注册过账号!', this);
        // }
      }
      if (this.locationAgentcode) {
        this.agentValue = this.locationAgentcode;
        this.checkedFavourable = true;
        this.changeChecked(true);
      }
    },
    // 打开弹框之前
    openNewBuyNowPop() {
      this.changeChoiceItem(0);
      this.getInvoiceInfo();
      this.checkOlderAgent();
    },
    // 打开升级弹框之前
    openUpdateNowPop() {
      this.getInvoiceInfo();
      this.updatePrice = this.updateBuyNowItem.spread;
    },
    // 打开用户协议之前
    openUserAgreement() {
      this.$nextTick(() => {
        let dom = document.querySelector("#word_11");
        dom.scrollIntoView();
      });
    },
    // 选择购买年限
    changeChoiceItem(index) {
      this.currentIndex = index;
      this.choiceItem = this.buyNowItem.filter((item, idx) => idx == index)[0];
      //   console.log(this.choiceItem);
      this.changeChecked(this.checkedFavourable);
    },
    // 是否使用优惠信息
    changeChecked(value) {
      if (value && (this.couponValue !== "" || this.agentValue !== "")) {
        let params = {
          amount: this.choiceItem.newprice,
          couponcode: this.couponValue,
          agentcode: this.agentValue,
        };
        this.$http
          .reqCaleCouponCodeAndAgentCode(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.couponAndAgentMsg = res.item;
                //console.log("tototo", res.item);
                this.caculateTotalPrice();
              }
            }
          })
      } else {
        this.couponAndAgentMsg = {};
        this.caculateTotalPrice();
      }
    },
    // 获取发票信息
    getInvoiceInfo() {
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          console.log("发票弹框按钮res===>", res);
          if (res.rtncode === 1 && res.rltcode === 1 && res.item != null) {
            if (res.item.headertype === 1) {
              // 个人
              this.invoiceWord = "普通发票 个人";
              this.invoiceData.invoiceheader = res.item;
            } else if (res.item.headertype === 2) {
              // 公司
              this.invoiceWord = "普通发票 公司";
              this.invoiceData.invoiceheader = res.item;
            }
            this.$refs.invoice.inputMsg(res.item);
          } else {
            this.invoiceWord = "普通发票 个人";
            this.$refs.invoice.inputMsg(this.invoiceData);
          }
        })
        .catch((err) => {
          console.log("开发票", err);
        });
    },
    // 选择发票信息
    choiceInvoice() {
      this.$refs.invoice.openpopup();
    },
    // 获取发票弹框的内容
    getInvoiceParams(params, word) {
      //console.log("获取发票的内容===》》》父组件params", params, word);
      this.invoiceData = params;
      this.invoiceWord = word;
    },
    // 计算总价
    caculateTotalPrice() {
      this.originalPrice = this.choiceItem.newprice;

      if (this.couponAndAgentMsg.amount !== undefined) {
        this.totalPrice = this.couponAndAgentMsg.amount.toFixed(2);
      } else {
        this.totalPrice = this.originalPrice.toFixed(2);
      }
    },
    onSubmit() {
      if (this.updateNowShow) {
        //   升级
        this.goToUpdataSure();
        return;
      } else if (this.buyNowShow) {
        //   购买
        if (!this.isXuFei) {
          // 购买
          this.goToBuySure();
        } else {
          this.goToContinueOrder();
        }
      }
    },
    // 确认去升级
    goToUpdataSure() {
      this.loadingFlag = true;
      console.log(this.buyItemProduct);
      if (this.isWX == 1) {
        this.updateByWxBrowm();
      } else {
        this.updateByOutWxBrowm();
      }
    },
    // 确认去购买支付
    goToBuySure() {
      this.loadingFlag = true;
      console.log(this.buyItemProduct);
      if (this.isWX == 1) {
        this.payByWxBrowm();
      } else {
        this.payByOutWxBrowm();
      }
    },
    // 确认去续费
    goToContinueOrder() {
      this.loadingFlag = true;
      console.log(this.buyItemProduct);
      if (this.isWX == 1) {
        this.continueByWxBrowm();
      } else {
        this.continueByOutWxBrowm();
      }
    },
    // 微信内购买支付
    payByWxBrowm() {
      let params = {
        product: this.buyItemProduct.code, // 购买的产品
        discount: this.choiceItem.discountcode, // 选择的优惠方式
        paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
        couponcode: this.couponValue, // 优惠码或优惠卷代码
        agentcode: this.agentValue, // 运营商编码
        invoice: this.invoiceData, // 开票相关信息
        wxopenid: sessionStorage.getItem("wxopenid"),
      };
      this.$http
        .reqPostProduceOrder(params)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.wxpayObj = JSON.parse(res.result.strdata);
              console.log(
                "微信内支付请求返回json参数2222====>",
                this.wxpayObj,
                res.result.orderid
              );

              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    // 一般浏览器购买支付
    payByOutWxBrowm() {
      let params = {
        product: this.buyItemProduct.code, // 购买的产品
        discount: this.choiceItem.discountcode, // 选择的优惠方式
        paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
        couponcode: this.couponValue, // 优惠码或优惠卷代码
        agentcode: this.agentValue, // 运营商编码
        invoice: this.invoiceData, // 开票相关信息
      };

      this.$http
        .reqPostProduceOrder(params)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.dataForm = res.result.strdata;
              console.log("主套餐支付this.dataForm", this.dataForm);
              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    // 微信内升级支付
    updateByWxBrowm() {
      let reqBody = {
        upproductcode: this.updateBuyNowItem.upproductcode,
        paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
        invoice: this.invoiceData,
        wxopenid: sessionStorage.getItem("wxopenid"),
      };
      this.$http
        .reqPostProductUpgrade(reqBody)
        .then((res) => {
          console.log(res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.wxpayObj = JSON.parse(res.result.strdata);
              console.log(
                "微信内支付请求返回json参数2222====>",
                this.wxpayObj,
                res.result.orderid
              );

              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    // 一般浏览器升级支付
    updateByOutWxBrowm() {
      let reqBody = {
        upproductcode: this.updateBuyNowItem.upproductcode,
        paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
        invoice: this.invoiceData,
      };
      this.$http
        .reqPostProductUpgrade(reqBody)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.dataForm = res.result.strdata;
              console.log("主套餐支付this.dataForm", this.dataForm);
              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    // 微信内续费支付
    continueByWxBrowm() {
      let params = {
        product: this.buyItemProduct.code, // 购买的产品
        discount: this.choiceItem.discountcode, // 选择的优惠方式
        paytype: 32, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
        couponcode: this.couponValue, // 优惠码或优惠卷代码
        agentcode: this.agentValue, // 运营商编码
        invoice: this.invoiceData, // 开票相关信息
        wxopenid: sessionStorage.getItem("wxopenid"),
      };
      
      // return;
      this.$http
        .reqPostProductContinueOrder(params)
        .then((res) => {
          console.log(res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.wxpayObj = JSON.parse(res.result.strdata);
              console.log(
                "微信内支付请求返回json参数2222====>",
                this.wxpayObj,
                res.result.orderid
              );

              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
          console.log("微信内主套餐支付", err);
        });
    },
    // 一般浏览器续费支付
    continueByOutWxBrowm() {
      let params = {
        product: this.buyItemProduct.code, // 购买的产品
        discount: this.choiceItem.discountcode, // 选择的优惠方式
        paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付  32微信内支付
        couponcode: this.couponValue, // 优惠码或优惠卷代码
        agentcode: this.agentValue, // 运营商编码
        invoice: this.invoiceData, // 开票相关信息
      };
      this.$http
        .reqPostProductContinueOrder(params)
        .then((res) => {
          console.log(res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.dataForm = res.result.strdata;
              console.log("主套餐支付this.dataForm", this.dataForm);
              this.getUserAgreement(res.result.orderid);
            } else {
              commonToast(res.rltdesc, this);
              this.loadingFlag = false;
            }
          } else {
            commonToast(res.rtndesc, this);
            this.loadingFlag = false;
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
          console.log("微信内主套餐支付", err);
        });
    },
    // 获取用户协议的内容
    getUserAgreement(orderid) {
      this.sumMoney = 0;
      this.$http
        .reqGetContractinfo(orderid)
        .then((res) => {
          console.log("获取用户协议的内容", res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.userAgreementData = res.item;
              this.userAgreementData.detail.forEach((item) => {
                this.sumMoney += item.amount;
              });
              console.log(this.userAgreementData, this.sumMoney);
              this.loadingFlag = false;
              this.userAgreementModal = true;
            }
          }
        })
        .catch((err) => {
          console.log("获取用户协议===》", err);
        });
    },
    // 关闭购买商品弹框
    closePop() {
      this.buyNowShow = false;
      this.updateNowShow = false;
      this.checkedFavourable = false;
      this.couponValue = "";
      this.agentValue = "";
      this.couponAndAgentMsg = {};
    },

    // 关闭用户协议弹框
    closePopup() {
      this.userAgreementModal = false;
    },
    // 确认支付
    agreePayMoney() {
      console.log(this.invoiceData)
      if (this.isWX == 1) {
        if (this.wxpayObj) {
          console.log("同意并确认支付是wx内", this.wxpayObj);
          wxpayFunc(this.wxpayObj, this.wxPayCallback);
        }
      } else {
        console.log("同意并确认支付this.dataForm", this.dataForm);
        location.href = this.dataForm;
      }
    },
    // 微信内支付回调函数
    wxPayCallback(res) {
      console.log("微信内支付完成====>", res);
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        commonDialog(
          "支付成功，您可以使用微信登录众智云擎。",
          this,
          "确认",
          () => {
            console.log("支付成功了调dialog");
            this.$http.refreshToken().then((res) => {
              this.bus.$emit("saveTokenHandle", res, 1);
              this.$router.push("/newFiles");
            });
          }
        );
      } else {
        warningNotify("用户支付失败!", this);
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.buy-pop {
  height: 100%;
  [class*='van-hairline']::after {
    border: none;
  }
  .wrap {
    padding: 45px 15px 20px;
    height: 100%;
    min-height: 620px;
    // .content-box-title {
    // height: 100%;
    // min-height: 620px;
    //   margin-bottom: 12px;
    //   font-size: 14px;
    //   color: #7b7b7b;
    // }
    .content {
      width: 100%;
      padding: 10px 0 2px 0;
      margin-bottom: 13px;
      background-color: #fff;
      border-radius: 10px;
      .content-userinfo {
        width: 204px;
        height: 18px;
        // padding-left: 13px;
        font-size: 14px;
        color: #000000;
        margin: 8px 0 8px 12px;
        font-weight: bold;
        font-size: 16px;
      }
      .content-buy-type {
        padding: 13px 13px 13px 13px;
        display: flex;
        justify-content: space-around;
        border-radius: 6px;
        
        .content-buy-type-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 128px;
          border: 1px solid #F1F1F1;
          border-radius: 10px;
          .original-price {
            text-decoration: line-through;
            color: #999;
            font-size: 12px;
          }
        }
        .choiceItem {
          background-color: #F9EFDE;
          border: 2px solid #E8B970;
          box-shadow: 0 1px 5px 0 rgba(249, 239, 222, 0.6);
        }
      }
    }
    .update-content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-bottom: 20px;

      div {
        font-size: 14px;
        padding: 10px 0;
        color: #999;
      }
      .update-content-box {
        border-radius: 6px;
        background-color: #fff;
        padding: 10px 16px;
        p {
          margin-bottom: 10px;
          b {
            font-weight: normal;
            margin: 0 4px;
            font-size: 16px;
            color: #9c7b59;
          }
          i {
            font-style: normal;
            color: #999;
          }
        }
      }
    }
    .favourable-box {
      position: relative;
      padding: 15px 0px 20px 0px;
      background-color: #fff;
      border-radius: 10px;
      .favourable-box-title {
        height: 20px;
        margin-bottom: 12px;
        padding: 0 10px;
        font-size: 16px;
        color: #000000;
        font-weight: bold;
      }
      .favourable-box-content {
        border-radius: 6px;
        margin-bottom: 15px;
        overflow: hidden;
      }
      .check-coupon {
        position: absolute;
        left: 20px;
        bottom: 10px;
      }
      /deep/.van-icon-success {
        color: #fff;
      }
      /deep/.van-checkbox__label {
        color: #999;
      }
      /deep/.van-field__label {
        color:#222b40;
      }
    }
    .invoice-box {
      width: 100%;
      height: 78px;
      font-size: 14px;
      margin: 13px 0  13px 0;
      background-color: #fff;
      border-radius: 10px;
      .invoice-box-title {
        color: #000000;
        font-weight: bold;
        font-size: 16px;
        padding: 10px 5px 5px 10px;
      }
      .van-cell--clickable {
        border-radius: 6px;
        color:#222B40;
      }
    }
    .pay-way {
      width: 100%;
      background-color: #fff;
      border-radius: 10px;
      padding: 10px 0;
      .pay-way-title {
        color:#000000;
        padding: 0px 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }
      .custom-title {
        height: 20px;
      }
    }
  }
  .pay-box {
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 65px;
    padding-right: 16px;
    background-color: #fff;
    padding: 0 20px;
    .pay-box-total {
      height: 44px;
      line-height: 50px;
      color: #232323;
    }
    .pay-btn {
      background: linear-gradient(to right, #F0D7B1, #EABD78);
    }
  }
}
</style>
